import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import "./CustomSelect.css"; // Ensure to style as needed

const CommonDropdown = forwardRef(({
  name,
  options,
  onSelect,
  placeholder = "Select...",
  value = "",
  disabled = false,
  onClear,
  enableSearch = true,
}, ref) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  // Allow ref to control the dropdown open/close state
  useImperativeHandle(ref, () => ({
    toggleDropdown: () => setShowDropdown((prev) => !prev),
    openDropdown: () => setShowDropdown(true),
    closeDropdown: () => setShowDropdown(false),
  }));

  useEffect(() => {
    setFilteredOptions(
      options.filter(
        (option) => option.label.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [searchQuery, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => setSearchQuery(e.target.value);
  
  const handleOptionClick = (option) => {
    onSelect(option);
    setShowDropdown(false);
    setSearchQuery(option.label);
  };

  return (
    <div className="custom-select-container" ref={dropdownRef}>
      <div className="input-wrapper">
        <input
          type="text"
          placeholder={placeholder}
          value={searchQuery}
          readOnly={!enableSearch}
          disabled={disabled}
          onClick={() => setShowDropdown(!showDropdown)}
          onChange={enableSearch ? handleInputChange : undefined}
        />
        {onClear && (
          <button className="clear-button" onClick={() => { setSearchQuery(""); onClear(); }}>
            Clear
          </button>
        )}
      </div>
      {showDropdown && (
        <ul className="dropdown-menu">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <li
                key={index}
                className="dropdown-item"
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </li>
            ))
          ) : (
            <li className="dropdown-item">No results found</li>
          )}
        </ul>
      )}
    </div>
  );
});

export default CommonDropdown;
